<div id="footerpage">
    <div class="content-container">
        <div class="pure-g footer_wrapper">
            <div class="pure-u-1 pure-u-md-12-24 img_sec">
                <a class="csllogo" routerLink="/home" title="CSLB logo">
                    <img src="/assets/img/CSLB_logo.svg" alt="CSLB logo" class="" />
                </a>
            </div>
            <div class="pure-u-1 pure-u-md-12-24 footer_menu">
                <ul>
                    <li><a href="https://www.csl.com/privacy-policy" target="_blank" title="Privacy Policy">
                        Privacy Policy</a></li>
                    <li><a href="https://www.cslbehring.ca/terms-of-use" target="_blank" title="Terms of Use">
                        Terms of Use</a></li>
                    <li><a href="https://www.csl.com/sitemap"  target="_blank" title="Sitemap">
                        Sitemap</a></li>
                </ul>
            </div>
        </div>
        <div class="horizontal_bor"></div>
        <div class="pure-g trade_sec">
            <div class="pure-u-1">
                <p>&copy;{{currentYear}} CSL Behring. All rights reserved.</p>
                <p>Hizentra<sup>&reg;</sup> is manufactured by CSL Behring AG and distributed by CSL Behring Canada Inc.
                </p>
                <p>HAEGARDA<sup>&reg;</sup> is a registered trademark of CSL Behring GmbH and is manufactured by CSL
                    Behring AG and distributed by CSL Behring Canada Inc.
                </p>
                <p>Behring AG and distributed by CSL Behring Canada Inc.</p>
                <p>Berinert<sup>&reg;</sup> is a registered trademark of CSL Behring GmbH. </p>
                <p>Humate-P<sup>&reg;</sup> is a registered trademark of CSL Behring GmbH.</p>
            </div>
        </div>
    </div>
</div>